import {RxBigRock} from "../../../../../../../common/model/db/types/RxBigRock";
import {useControllers} from "../../../../../../../common/helpers/react/hooks/useControllers";
import {RxProperty} from "../../../../../../../common/model/db/types/RxProperty";
import {ColumnDescription} from "../../../../../common/components/table/ColumnDescription";
import {tAsString} from "../../../../../../../common/helpers/react/text/tAsString";
import DefaultListTable from "../../../../../common/components/table/DefaultListTable";
import DefaultTableInput from "../../../../../common/components/table/inputs/DefaultTableInput";
import {asString} from "../../../../../../../common/helpers/converters/asString";
import {RxGroupProperty} from "../../../../../../../common/model/db/types/RxGroupProperty";
import {DefaultWizardHelpers} from "../../../../../common/components/wizards/DefaultWizardHelpers";
import {asObjectOrNull} from "../../../../../../../common/helpers/converters/asObjectOrNull";
import {PropertyState} from "../../../../../../../common/model/types/properties/PropertyState";
import {default as React} from "react";

export type BigRockBodyProps = {
    bigRock: RxBigRock,
    groupId: string,
    wh: DefaultWizardHelpers,
    isOn: boolean
}

export const BIG_ROCK_PROPERTIES_SET_KEY: string = 'big_rock_properties_set';

export function BigRockBody(props: BigRockBodyProps): JSX.Element {
    const controllers = useControllers();
    const bigRocks = controllers.bigRocks;

    const properties: RxProperty[] = bigRocks.getBigRockProperties(props.bigRock.id).useState() ?? [];
    const propertiesSet: RxGroupProperty[] = bigRocks.getBigRockPropertiesSet(props.bigRock.id).useState() ?? [];

    const wh = props.wh;
    const stepData = wh.stepData;

    const allPropertiesSetInStepData = asObjectOrNull(stepData?.[BIG_ROCK_PROPERTIES_SET_KEY]);
    const brPropertiesSetInStepData = asObjectOrNull(allPropertiesSetInStepData?.[props.bigRock.id]);

    const columns: ColumnDescription<RxProperty>[] = [
        {
            header: tAsString('FEATURE'),
            size: 1,
            name: 'name'
        },
        {
            header: tAsString('SETTINGS'),
            size: 2,
            render: row => {
                const type = Object.keys(row.possible_values ?? {}).length
                    ? 'select'
                    : 'text'

                const options = [
                    {
                        label: '-- Select --',
                        value: ''
                    },
                    ...Object.keys(row.possible_values ?? {}).map(it => {
                        return {
                            label: asString(row.possible_values?.[it]),
                            value: it
                        }
                    })
                ];

                const defaultValue = (brPropertiesSetInStepData?.[row.id] as PropertyState)?.overrideValue
                    ?? propertiesSet
                        .find(it => it.id === props.groupId + '_' + props.bigRock.group_rock_role + '_' + row.id)
                        ?.override_value
                    ?? '';

                const onChange = async (e: React.ChangeEvent, value: string) => {
                    await wh.setStepMember([BIG_ROCK_PROPERTIES_SET_KEY, props.bigRock.id, row.id], {
                        id: row.id,
                        overrideValue: value,
                        allowUserOverride: 'true',
                        bigRockName: props.bigRock.name,
                        bigRockDestiny: props.bigRock.destiny
                    });
                }

                return <DefaultTableInput
                    name={`big_rock_prop_${row.id}`}
                    type={type}
                    options={options}
                    defaultValue={asString(defaultValue)}
                    onChange={onChange}
                />
            }
        },
        {
            header: tAsString('DESCRIPTION'),
            size: 3,
            name: 'description'
        }
    ];

    return props.isOn && props.bigRock.property_ids?.length
        ? <DefaultListTable
            columns={columns}
            data={properties}
            rowProps={(row) => ({
                className: 'qa_' + row.name?.replaceAll(/[^a-zA-z0-9]/g, "_").toLowerCase()}
            )}
            className={"qa_" + props.bigRock.name.replaceAll(" ", "_") + "_table"}/>
        : <></>;
}